let $=window.$;
//let URL= window.location.host.includes('http://')?window.location.host.replace('https://','https://'):'https://'+window.location.host
let URL= window.location.host.includes('http://')?window.location.host.replace('https://','https://'):'https://'+window.location.host;
export const FILE_URL='https://clubmiracle.asia/VM/files/';
export const path = '/villa/';
export const _showOverlay = () => {
    // Adds the fullscreen overlay
    var oDiv = $("<div></div>");
    oDiv.attr("id", "lt_overlay");
    oDiv.css("display", "block");
    $("body").append(oDiv);

    // Adds the spinner
    var lDiv = $('<i class="fas fa-cog fa-spin"></i>');
    lDiv.attr("id", "lt_loading");
    lDiv.addClass("fa fa-cog fa-spin fa-5x");
    lDiv.css("display", "block");
    $("body").append(lDiv);
}

/**
 * 
 */
export const _hideOverlay = () => {
    $("#lt_loading").remove();
    $("#lt_overlay").remove();
}

/**
 * 
 * @param {*} languages 
 * @returns 
 */
export const _getSiteLanguage=(languages)=>{
    let language = window.navigator.userLanguage ;
    let selected_flag='en';
    if(typeof language !== "undefined" && language != null){
         if(languages.includes(language.split('-')[0])){
               alert(language);
               selected_flag=language.split('-')[0];
         }
    }
    let loca_lang=window.sessionStorage.getItem('language');
    if(typeof loca_lang !== "undefined" && loca_lang != null){
        selected_flag=loca_lang;
    }
    return selected_flag;
}

/**
 * 
 */
 export const _validateRegistration = async (data) => {

    let email = data.get('email');
    let first_name = data.get('first_name');
    let last_name = data.get('last_name');
    let message = data.get('message');
    let phone_number = data.get('phone_number');
    let country = data.get('country');
  

    //let user_name = data.get('first_name');
    let response = [];
    response['status'] = false;
    response['error'] = [];

    if (typeof email != "undefined" && email != null && email.trim() != '' && typeof first_name != "undefined" && first_name != undefined && first_name.trim() != ''
        && typeof last_name != "undefined" && last_name != null && last_name.trim() != '' && typeof message != "undefined" && message != undefined && message.trim() != ''
        && typeof phone_number != "undefined" && phone_number != null && phone_number.trim() != '' && typeof country != "undefined" && country != undefined && country.trim() != ''
        ) {
        if (_validateEmail(email)) {
            response['status'] = true;

        } else {
            response['error']['email'] = "Please provide a valid Email Address";

        }
    } else {
        response['error']['email'] = _checkNull(email);

        if (response['error']['email'].trim() == '' || response['error']['email'] == null) {
            if (_validateEmail(email)) {
                
            } else {
                response['error']['email'] = "Please provide a valid Email Address";
            }
        }
        response['error']['first_name'] = _checkNull(first_name);
        response['error']['last_name'] = _checkNull(last_name);
        response['error']['message'] = _checkNull(message);
        response['error']['country'] = _checkNull(country);
        response['error']['phone_number'] = _checkNull(phone_number);
        if (response['error']['phone_number'].trim() == '' || response['error']['phone_number'] == null) {

            if (_validateNumber(phone_number)) {
                //response['status'] = true;
            } else {
                response['error']['phone_number'] = "Please provide a valid phone number";

            }
        }
        response['error']['country'] = _checkNull(country);
    }

    return response;
}

/**
 * 
 * @param {*} data 
 */
 export const _validateNumber = (data) => {
    let response = false;
    var pattern = /[^0-9]/g;
    var result = data.match(pattern);

    if (result == null) {
        response = true;
    }
    return response;
}

/**
 * 
 * @param {*} field 
 */
export const _checkNull = (field) => {
    let error = '';

    if (typeof field == "undefined" || field == null || ( !Array.isArray(field) &&  field.trim() == '')) {
        error = "This field is required";
    }else{
        if(field.length == 0){
            error = "This field is required";
        }
    }
    return error;
}


/**
 * 
 * @param {*} email 
 */
 export const _validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export const _currentTimeStamp = () => {
    var dt = new Date();
    var time = dt.getHours() + "" + dt.getMinutes() + "" + dt.getSeconds();
    return time;
}

export const _wait = (selector) => {
  return new Promise((resolve, reject) => {
    const waitForEl = (selector, count = 0) => {
      const el = $(selector);

      if (!!el) {
        resolve(el);
      } else {
        setTimeout(() => {
          count++;

          if (count < 10) {
            _wait(selector, count);
          } else {
            reject();
          }
        }, 100);
      }
    };

    _wait(selector);
  });
};